//德语文件
module.exports = {
  header1: "Startseite",
  header2: "Über uns",
  header2_1: "Wer sind wir",
  header2_2: "Warum uns wählen",
  header3: "Handelsplattform",
  header4: "MT5-Leitfaden",
  header5: "Kontaktieren Sie uns",
  header6: "Eröffnen Sie ein echtes Konto",
  header7: "Anmelden",
  header8: "Registrieren",
  footer1: "Schließen Sie sich der Reihe der Händler an",
  footer2: "Kostenlose Testversion",
  footer3: "Beginnen Sie sofort mit dem Handel",
  footer4: "Folge uns",
  footer5: "Urheberrecht",
  footer6: "Alle Rechte vorbehalten",
  home1: "Handelsprodukte",
  home2: "Einzahlungsgebühr ist kostenlos",
  home3: "So niedrig wie Nullpunktdifferenz",
  home4: "Handel ist überall möglich",
  home5: "Mehr als 200 handelbare Produkte",
  home6: "9 Optionen für den Zeitraum",
  home7: "Sie können sich auf PC und Handy in Ihr Konto einloggen",
  home8: "Professionelle Analysetools",
  home9: "MT5 für PC herunterladen",
  home10: "Internethändler",
  home11: "Kein Download oder Installation erforderlich",
  home12: "Zugriff auf Ihr Konto mit jedem Webbrowser",
  home13: "So leistungsstark wie MT4",
  home14: "Verbindung mit dem Markt für Transaktionen jederzeit und überall",
  home15: "Öffne die Webversion von mt5",
  home16: "Hilf dir, es zu schaffen",
  home17: "Beste Handelsentscheidung",
  home18:
    "Verwenden Sie diese Handelstools, um die informierteste Entscheidung zu treffen",
  home19: "Intelligentes Handelssystem",
  home20: "Trading-Vorteile durch professionellen EA erhalten",
  home21: "Handelssignal",
  home22: "Es führt dich wie ein Leuchtfeuer zum Erfolg.",
  home23: "Wirtschaftskalender",
  home24: "Die neuesten Markttrends beherrschen",
  home25: "Protrader-Tool",
  home26: "Mehr Handelsmöglichkeiten erhalten",
  home27: "Marktnachrichten",
  home28: "Ausgewählte Marktansichten",
  home29: "Analystenansicht",
  home30: "Professioneller Wirtschaftskalender",
  home31:
    "Eröffnen Sie ein Handelskonto und zahlen Sie mindestens 1.000 USD ein",
  home32:
    "Sie können einen vollständigen Satz professioneller Handelstools verwenden",
  home33: "Sofortige Einzahlung",
  home34: "Eröffne ein echtes Konto",
  home35: "Perfekte Erfahrung",
  home36: "Extrem schnelle Ausführung von Handelsaufträgen",
  home37:
    "'Was sind die Schlüsselelemente, wenn Händler einen Devisenmakler wählen?'-Diese Frage stellen wir uns bei der Gründung von {platform}. Wir glauben, dass diese Elemente unseren Wert definieren und es uns ermöglichen, unsere Kunden zufrieden zu stellen Der Kern zu fordern und weiterhin exzellenten und zuverlässigen Service zu bieten.",
  home38: "Kontoeröffnung in 5 Minuten",
  home39: "Eine Kombination aus mehr als 200 handelbaren Rohstoffen",
  home40: "Voll funktionsfähiges Kontoführungssystem",
  home41: "Ausgezeichnete Marktliquidität",
  home42: "Mehr erfahren",
  home43: "Compliance-Überwachung",
  home44: "Geben Sie die beste Sicherheit",
  home45:
    "{platform} legt großen Wert auf Aufsicht und Sicherheit. Wir bieten allen Kunden ein transparentes und sicheres Devisenhandelsumfeld.",
  home46: "Globales Büro",
  home47: "Multinationale Aufsicht",
  home48: "Zusammenarbeit mit den weltweit führenden Finanzinstituten",
  home49: "Fondsversicherung",
  home50: "Aufsicht",
  home51: "Entschädigung",
  home52: "Versicherung",
  home53: "Einzahlungsmethode",
  home54: "Marktliquiditätspartner",
  home55:
    "{platform} arbeitet mit mehr als 14 weltweit führenden Anbietern von Liquiditätsquotierungen zusammen, und ausreichende Liquidität kann Ihnen die besten Handelsquoten auf dem Markt bieten",
  home56: "Devisenhandel",
  home57:
    "Die weltweiten wirtschaftlichen Turbulenzen nutzen, um den liquidesten Finanzmarkt der Welt zu verbinden",
  home58: "Beginnen Sie sofort mit dem Handel",
  home59: "Sperrguthandel",
  home59_1: "Massentransaktion",
  home60:
    "Wählen Sie Gold, Silber, Rohöl oder andere Soft Commodities basierend auf dem Hauptmarkt-Handelszyklus",
  home61: "Indexhandel",
  home61_1: "Index",
  home62:
    "Trade durch die Schwankungen der großen Aktienindizes der Welt wie SP500, DJ30, FRA40 und DAX30",
  home63: "US/Hong Kong Stock Exchange",
  home64:
    "Meistern Sie die Trends großer globaler Unternehmen und handeln Sie US- und Hongkong-Aktien mit CFDs",
  home65: "Differenzvertrag",
  home66: "Globales Geschäft",
  home67:
    "Es ist uns eine Ehre, unseren Kunden einen erstklassigen und stabilen Service zu bieten",
  home68: "Handel mit Webversionen",
  who0: "Wer ist {Plattform}",
  who1: "Werden Sie Teil des innovativsten Brokers",
  who2:
    "{platform} Es verfügt über mehr als 10 Jahre Erfahrung und Expertise auf dem globalen Finanzmarkt und ist bestrebt, einen einfachen und transparenten Marktzugang zu bieten und zu helfen Kunden erreichen finanzielles Ziel.",
  who3:
    "{platform} 2010 in Großbritannien gegründet und hält sich immer an das Konzept 'Genießen Sie den Handel jederzeit und überall'. Transaktionen ECN-Konto und ein leistungsstarkes Kundenverwaltungssystem.",
  who4: "Wählen Sie einen vertrauenswürdigen Devisenmakler",
  who5:
    "{platform1} war schon immer bestrebt, seinen Kunden ein hervorragendes Handelsumfeld zu bieten, und hat immer darauf bestanden, die Erwartungen der globalen Finanzaufsichtsbehörden zu übertreffen. In dieser Branche wissen wir, dass Händler begierig darauf sind, eine vertrauenswürdige Plattform zu finden. {platform2 }Unter der Aufsicht mehrerer Institutionen haben wir mehr als 10.000 aktive Kundenhandelskonten aus der ganzen Welt aufgebaut, und alle verlassen sich auf {platform3}, um die Sicherheit ihrer Gelder zu gewährleisten.",
  who6: "Hauptregulierungsbehörde",
  who6_1: "U.S. NFA Regulation, Registration ID: 0542569",
  who7: "Globale Anzahl von Personen",
  who8:
    "Als einer der Marktführer auf dem globalen Finanzmarkt bietet {platform} unseren Kunden erstklassige und stabile Dienstleistungen.",
  who9: "Im Folgenden sind einige relevante Daten von {platform}:",
  who10: "10 Jahre+",
  who11: "Branchenqualifikation",
  who12: "„Über 1,5 Milliarden“",
  who13: "Monatliches Transaktionsvolumen",
  who14: "Über 7M",
  who15: "Kundenkonto",
  who16: "1,5 Milliarden $",
  who17: "Monatliches Transaktionsvolumen",
  why0: "Warum {Plattform} wählen",
  why1: "Nicht nur eine Plattform, sondern ein Partner",
  warum2:
    "'Was wollen Händler bei der Wahl eines Devisenmaklers? '-Diese Fragen haben wir uns bei der Gründung von {platform} immer wieder gestellt. Ich glaube, dass diese Elemente der Kern sind, der unsere Werte definiert, damit wir die Bedürfnisse unserer Kunden erfüllen und weiterhin exzellente und zuverlässige Dienstleistungen anbieten können.",
  why3:
    "„Das Wichtigste ist, dass wir eine Marke aufbauen wollen, die über Preis oder Produkt hinaus bekannt ist. Wir wollen eine Marke werden, die in der neuen Generation gehandelt wird. Die Kenntnis der Bedürfnisse unserer Kunden ermöglicht uns, Veränderungen vorzunehmen flexibler. Wir sind eine neue Hochleistungsmarke. Generation Handelsplattform, {platform} ist immer an Ihrer Seite, wenn Sie sie brauchen.",
  why4: "Wir sind während der Handelsreise an Ihrer Seite",
  Why5:
    "Ob Sie ein langjähriger Anfänger oder ein erfahrener Trader sind, unser Team unterstützt Sie jederzeit. Unsere Plattform ist immer und überall bei Ihnen und unser Kundenservice-Team begleitet Sie bei jedem Schritt, Wir wird Sie begleiten, um gemeinsam zu wachsen. Auch wenn unsere Konkurrenten stärker sind als wir, haben wir den Antrieb für Innovation und die Unterstützung einer konformen Handelsplattform. Erfahren Sie, warum {platform} Ihre richtige Wahl ist: ",
  why6: "Eröffne sofort ein Echtgeldkonto in 5 Minuten",
  why7: "Hebel bis zu 500:1",
  Why8: "Mehr als 200 Arten von Rohstoffen können gehandelt werden",
  why9: "Zusätzlichen Handelsbonus bereitstellen",
  why10: "Leistungsstarkes Client-Management-System",
  why11: "Ausgezeichnete Marktliquidität",
  why12: "Mehrere Aufsichtsbehörden und getrennte Konten als Garantie",
  Trading1: "Verwenden Sie die Metatrader5-Plattform",
  Trading2: "Trade jederzeit und überall",
  trading3:
    "Wenn Sie ein neuer Kunde von {platform} sind, füllen Sie einfach das Formular oben auf dieser Seite aus und Sie können die MT5-Handelsplattform innerhalb weniger Minuten nutzen.",
  Trading4:
    "Wenn Sie bereits ein {platform}-Kunde sind, der auf der MT5-Plattform handelt, müssen Sie sich nur bei Ihrem Kundenmanagement-Hintergrund anmelden, klicken, um Ihr Konto zu eröffnen und MetaTrader5 auszuwählen, Sie können nahtlos zu MT5 wechseln und weiter verbessern Ihre Handelserfahrung. ",
  trading5:
    "Mit der mobilen MT5-App können Sie sich jederzeit und überall mit {platform} verbinden und wetterunabhängige Handelsdienste genießen.",
  guide0: "MT5-Leitfaden",
  Anleitung1: "Laden Sie MT5 auf Ihren Computer herunter",
  guide3: "Wie füge ich Chartquoten ein?",
  guide3_0: "Folgen Sie den Schritten unten:",
  guide3_1:
    "1) Wählen Sie in der oberen Menüleiste, ob Sie ein Kontingent einfügen möchten.",
  guide3_2:
    "2) Sie können auch eine Quote aus dem Navigationsbereich einfügen.",
  guide4: "Wie vermeide ich den Firewall-Schutz?",
  guide4_1:
    "Verbieten Sie Ihrer Antiviren-Firewall, sich für MetaTrader 4 zu bewerben und Port 1950 zu öffnen. Für MetaTrader 5, öffnen Sie Port 443.",
  guide5: "Wie erstelle ich Trendlinien und andere Forschungslinien?",
  guide5_1: "1) Wählen Sie in der oberen Menüspalte 'Einfügen' aus",
  guide5_2: "2) Wählen Sie die gewünschte Trendlinie.",
  guide5_3:
    "3) Nach dem Loslassen der Maustaste erscheint ein Bildsymbol der ausgewählten Trendlinie mit einem Fadenkreuz. Verwenden Sie die Maus, um das Fadenkreuz auf dem ausgewählten Chart zu platzieren. Klicken Sie mit der Maus, halten Sie sie gedrückt, um zu verschieben Verwenden Sie die Maus zum Anpassen die Größe der Trendlinie.",
  guide5_4:
    "Das Shortcut der Linienrecherche kann auch schnell über die Symbolleiste 'Durchsuchen der Linienrecherche aufgerufen werden, so dass das Icon nur unter der Funktionsliste erscheint.",
  guide5_5:
    "Sie können auch andere Optionen auswählen, die oben auf dem Bildschirm angezeigt werden. Dazu gehören das Klicken auf Trendlinien, Fadenkreuze, Fibonacci-Retracements usw.",
  guide6: "Wie zeige ich das Balkendiagramm an?",
  guide6_1:
    "Wählen Sie in der Menüleiste oben 'Chart Bar Graph' oder verwenden Sie die Tastenkombination (Alt+1)",
  guide7:
    "Wie erhalte ich Kontoinformationen und tägliche Transaktionen auf der Metatrader-Plattform?",
  guide7_1:
    "Bitte verwenden Sie den Terminal (TERMINAL)-Teil der Plattform. Wenn Sie diesen Teil nicht öffnen, können Sie den Terminal-TERMINAL durchsuchen oder die Tastenkombination Strg+t verwenden.",
  guide7_2: "Wählen Sie im Terminalbereich 'Kontoverlaufs-Tag'.",
  guide7_3:
    "Diese Markierung zeigt Ihnen den Verlauf Ihres Kontos. Er kann auch bequem ausgedruckt werden.",
  guide7_4:
    "Klicken Sie mit der rechten Maustaste auf eine beliebige Stelle in diesem Abschnitt.",
  guide7_5:
    'Wählen Sie "Als Bericht speichern". (Es kann auch als HTML-Datei gespeichert werden, die zur Aufzeichnung in eine Excel-Datei konvertiert werden kann.)',
  guide8: "Wie zeige ich das Candlestick-Chart an?",
  guide8_1:
    'Wählen Sie in der oberen Menüleiste "Chart Candlestick" oder verwenden Sie die Tastenkombination (Alt+2).',
  guide9:
    "Kann ich die MetaTrader-Anwendungsschnittstelle auf Ihrem System verwenden? Kann dies zuerst auf dem Mini-/Analogkonto erfolgen?",
  guide9_1:
    "Ja, solange Sie möchten, können Sie zunächst den analogen Account nutzen. Generell gelten für die Applikationsschnittstelle zum realen Systemzugriff besondere Bedingungen. Bitte besprechen Sie Ihr Projekt unbedingt mit einem FXDD-Vertreter, damit , Sie können dir helfen.",
  guide10: "Wie zeige ich das Liniendiagramm an?",
  guide10_1:
    'Wählen Sie in der oberen Menüleiste "Chart line graph" oder verwenden Sie die Tastenkombination (Alt+3).',
  guide11: "Wie kann ich das Diagramm vergrößern oder verkleinern?",
  guide11_1:
    "1) Stellen Sie sicher, dass die Symbolleiste 'Diagramm' aktiviert ist",
  guide11_2:
    "2) Wählen Sie als nächstes das Symbol der sinnvollen Aktion aus, die sich unter der Funktionsliste befindet, nämlich ‚+‘ und ‚-‘.",
  guide11_3:
    "3) Wählen Sie eines der beiden Symbole zum Vergrößern oder Verkleinern.",
  guide11_4:
    "Oder verwenden Sie die Tastenkombination für diese Funktion. Vergrößern ist (Umschalt +) und Verkleinern ist (-).",
  guide12: "Hilf die MetaTrader-Plattform beim Mini-Hand-Trading (10K)?",
  guide12_1:
    "Ja, Sie können die MetaTrader-Plattform verwenden, um Mini-Lots (10K) zu handeln.",
  guide12_2:
    "Die folgenden Lotgrößen verwenden wir für den Handel auf Metatrader:",
  guide12_3:
    "0.01 Lot = 1000 Basiswährung der Organisation (oder US-Dollar) unser 'Super Mini' Lot.",
  guide12_4:
    "0,10 Lot = 10000 Basiswährung der Organisation (oder US-Dollar) unser 'Mini'-Lot.",
  guide12_5:
    "1.00 Lot = 100000 unser 'Standard'-Lot der Basiswährung (oder US-Dollar) der Organisation.",
  guide13:
    "Ich habe die Plattform heruntergeladen. Wie melde ich mich bei meinem echten Konto an, um zu handeln?",
  guide13_1:
    "Der Benutzer sollte eine E-Mail-Benachrichtigung über die Kontogenehmigung erhalten haben. Der Login-Name und das Passwort sind in der Benachrichtigung angegeben (dh der Login-Name ist '81234' und das Passwort ist 'xxxxx'). Dies sind die Kontoinformationen von Ihr echtes Konto. Wenn Sie die Plattform heruntergeladen und den Anmeldebildschirm geöffnet haben. Beachten Sie, dass der Bildschirm, der sich zu diesem Zeitpunkt öffnet, Sie auffordert, ein Konto zu eröffnen. Sie können auf 'X' klicken, um diesen Bildschirm zu verlassen.",
  guide13_2:
    "Wählen Sie beim Anmelden 'Datei-Login' und geben Sie Ihren Login-Namen und Ihr Passwort ein.",
  guide13_3:
    "Das Serverfeld hat ein Dropdown-Menü, wählen Sie den folgenden Server aus: ‘FXDD-MT5 Live Server 2-FXDD’.",
  guide13_4:
    "Hören Sie auf den 'Ding'-Ton (Bestätigungston), Ihr Konto wird in der oberen linken Ecke der Plattform angezeigt.",
  guide13_5:
    "Wenn Sie die Kursbewegung in der Market Watch sehen und der korrekte Saldo auf dem Terminalteil angezeigt wird, haben Sie sich erfolgreich in Ihr Echtgeldkonto eingeloggt. Wenn Sie Probleme beim Einloggen haben, senden Sie bitte eine E-Mail an info support@leedword.com.",
  guide14: "Wie ändere ich mein Passwort bei MetaTrader?",
  guide14_1:
    "Wählen Sie in der oberen Menüleiste 'Werkzeugoptionen' oder die Tastenkombination (Strg+O).",
  guide14_2: "Wählen Sie unter dem Symbol 'Server' 'Bearbeiten'.",
  guide14_3:
    "Geben Sie das aktuelle Passwort in das Textfeld 'Aktuelles Passwort' ein.",
  guide14_4: "Häkchen bei 'Master-Passwort ändern' an",
  guide14_5:
    "Geben Sie das neue Passwort in das Textfeld 'Neues Passwort'  ein.",
  guide14_6:
    "Geben Sie das neue Passwort im zweiten Textfeld 'Bestätigen' erneut ein.",
  guide15: "Wie wähle ich eine Sprache?",
  guide15_1:
    "Wählen Sie in der oberen Menüleiste 'Sprache durchsuchen', wählen Sie Ihre bevorzugte Sprache. Schließen Sie dann die Plattform und starten Sie das Programm neu.",
  guide16:
    "Welche Tastenkombinationen können verwendet werden, um verschiedene Fenster auf der Plattform anzuzeigen?",
  guide16_1: "Die am häufigsten verwendeten Tastenkombinationen sind:",
  guide16_2: "Strg+M=Marktpreisbeobachtungsfenster",
  guide16_3: "Strg+N=Navigationsfenster",
  guide16_4: "Strg+T=Terminalfenster",
  guide17:
    "Wie kann ich alle von FXDD bereitgestellten Währungspaare anzeigen?",
  guide17_1:
    "Klicken Sie im Market Watch-Fenster mit der rechten Maustaste und wählen Sie 'Alle anzeigen', um alle handelbaren Währungspaare anzuzeigen. Alle Währungspaare können jederzeit angezeigt werden.",
  guide18: "Wie zeige ich hohe/niedrige Kurse im Market Watch-Fenster an?",
  guide18_1:
    "Führen Sie im Market Watch-Fenster die folgenden Schritte aus, um hohe/niedrige Preise anzuzeigen:",
  guide18_2: "Rechtsklick (beliebiger Teil) im Market Watch-Fenster",
  guide18_3:
    "Wählen Sie 'Hoch'/'Niedrig'. (Zu diesem Zeitpunkt werden die Höchst- und Tiefstkurse jedes Währungspaares des Tages angezeigt.)",
  guide19:
    "Können Sie die Erstellung von Diagrammen anleiten? Welche Optionen gibt es?",
  guide19_1:
    "Ja, die MetaTrader 5-Plattform ist eine der fortschrittlichsten Plattformen auf dem Markt, insbesondere die Grafikoptionen und -pakete.",
  guide19_2:
    "Verwenden Sie die Option 'Hilfethemen' im Hilfemenü (drücken Sie F1) und markieren Sie den Abschnitt 'Arbeiten mit dem Diagramm beginnen'. Dieser Abschnitt sollte als guter Anfang verwendet werden.",
  guide19_3:
    "Sie können das Gesamterscheinungsbild des Diagramms ändern ('Funktionsliste'-'Diagramm'-'Inhalt'). Sie können die Farbe des Hintergrunds, Vordergrunds, der Tabelle usw. ändern. Sie können den Rand des Diagrammfenster, um die Größe des Diagramms anzupassen, und ziehen Sie die Maustaste, um die Größe zu ändern.",
  guide20: "Wie kann man den Anzeigezeitraum von MetaTrader-Charts ändern?",
  guide20_1:
    "Wenn Sie der Hauptmenüleiste ein Zeitlimit hinzufügen, wählen Sie 'Browse Toolbar'. 'Periode' (falls erforderlich). Verwenden Sie die folgende Legende, um das Zeitlimit im Diagramm zu verwenden:",
  guide20_2: "M1=1 Minuten-Chart",
  guide20_3: "M5=5-Minuten-Chart",
  guide20_4: "M15=15-Minuten-Chart",
  guide20_5: "M30=30-Minuten-Chart",
  guide20_6: "H1=1 Stundenchart",
  guide20_7: "H4=4-Stunden-Chart",
  guide20_8: "D1=Tagesdiagramm",
  guide20_9: "W1=Wochendiagramm",
  guide20_10: "MN=Monatschart",
  guide21: "Gibt es eine Bedienungsanleitung für MetaTrader 5?",
  guide21_1:
    "Ja, wählen Sie auf der Plattform 'Hilfethemen' oder klicken Sie hier zum Download. Bitte beachten Sie, dass wir Online-Seminare anbieten, die Ihnen helfen, die Funktionen dieser Plattform zu verstehen. Wenn Sie an diesen Online-Seminaren teilnehmen möchten Ja, Bitte senden Sie eine E-Mail an den Vertrieb.",
  guide22:
    "Was ist die Zeitzone auf der Metatrader-Plattform? Kann diese Zeit angepasst werden?",
  guide22_1:
    "Im Sommer ist die Zeit des Kunden auf MetaTrader GMT+3 (Greenwich Mean Time plus 3 Stunden, Beijing Time plus 5 Stunden). Leider kann die Zeit auf der MetaTrader-Plattform nicht geändert werden. Alles, was dadurch verursacht wird Wir sind zutiefst Entschuldigung für die Unannehmlichkeiten.",
  guide23:
    "Wie eröffne ich ein weiteres analoges Konto auf der MetaTrader-Plattform?",
  guide23_1:
    "Wählen Sie 'Datei zum Eröffnen eines Kontos' in der Plattform aus",
  guide23_2:
    "Geben Sie die erforderlichen Informationen ein (kreuzen Sie unbedingt die Spalte 'Ich stimme zu, Ihren Newsletter zu abonnieren' an)",
  guide23_3: "Wählen Sie 'Weiter' (auf der Serverseite)",
  guide23_4:
    "Wählen Sie 'Weiter' (Bitte beachten Sie, dass Ihr Benutzername und Ihr Passwort angezeigt werden)",
  guide23_5: "Wählen Sie 'Fertig stellen'",
  guide23_6:
    "Diese Software meldet Sie automatisch bei Ihrem neuen analogen Konto an und zeigt es im Navigationsfenster an.",
  guide24: "Welche Faktoren beeinflussen den Kommunikationsumfang im Programm?",
  guide24_1:
    "Der Umfang der Ausgabekommunikation hängt von der Aktivität des Benutzers ab und ist recht gering. Der Umfang der Eingabekommunikation hängt direkt von der Anzahl der geöffneten Grafikfenster ab.",
  guide25: "Kann ich Warnungen per E-Mail erhalten?",
  guide25_1:
    "Folgen Sie den Schritten unten, um eine E-Mail-Benachrichtigung in MetaTrader 5 zu erstellen:",
  guide25_2:
    "(Alle SMTP-Einstellungen (Simple Mail Transfer Protocol) variieren je nach Internetdienstanbieter. Wenn Sie eine Fehlermeldung erhalten, wenden Sie sich an den technischen Support Ihres Internetdienstanbieters und bitten Sie ihn, das Simple Mail Transfer Protocol zu implementieren. Wenn Sie Outlook verwenden, können Sie wählen Sie 'Extras E-Mail-Kontoänderung nächster Schritt', um den Vorgang abzubrechen), um das einfache E-Mail-Übertragungsprotokoll festzulegen.",
  guide25_3: "Wählen Sie 'Werkzeugoptionen' aus",
  guide25_4: "Wählen Sie das Symbol 'E-Mail' aus.",
  guide25_5:
    "Bearbeiten Sie die obigen Einstellungen gemäß den Anforderungen Ihres Internetdienstanbieters. Normalerweise ist der hellrote Text die allgemeine Richtlinie für die Anmeldung. Bitte wenden Sie sich an Ihren Internetdienstanbieter, um spezifische Anweisungen zu erhalten. (Hinweis: Nicht verfügbare Web-E-Mail-Dienste umfassen Hotmail, Yahoo, Gmail usw.)",
  guide25_6:
    "Simple Mail Transfer Protocol Server - Dies ist die Mailserveradresse Ihres Internetdienstanbieters",
  contact1: "Wenn Sie uns brauchen, sind wir immer an Ihrer Seite",
  contact2:
    "Wenn Sie Fragen haben oder weitere Hilfe benötigen, kontaktieren Sie uns bitte über die folgenden Kontaktmethoden. Wir werden unser Bestes geben, um alle Fragen so schnell wie möglich zu beantworten.",
  contact3: "Anmeldung",
  contact4: "Cayman-Büro",
  contact5: "Büro",
  Kontakt6: "Nr. 7, Abschnitt 5, Bezirk Xinyi, Taipeh, Taiwan (Taipei 101)",
  contact7: "E-Mail-Adresse",
  contact8: "Telefon",
  Adresse1: "Australien, Sydney",
  Adresse2: "Taipeh",
  Adresse3: "Thailand, Bangkok",
  Adresse4: "Malaysia, Kuala Lumpur",
  Adresse5: "Großbritannien, London",
  Adresse6: "Vereinigte Staaten, New York",
  Adresse7: "Singapur, Singapur-Stadt",
  Adresse8: "Cayman Islands, George Town",
  Adresse9: "Zypern, Nikosia",
  Adresse10: "Hongkong",
  Adresse11: "Vietnam, Hanoi",
  Adresse12: "Australien, Melbourne"
};



// WEBPACK FOOTER //
// ./src/common/lang/de.js